const STORAGE_KEY = 'device_id'

let cached: string | null = null

function generate(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

/** Стабильный ID установки веб-клиента для антифрода (заголовок X-Device-Id). */
export function getDeviceId(): string {
  if (cached) return cached
  try {
    cached = localStorage.getItem(STORAGE_KEY)
    if (!cached) {
      cached = generate()
      localStorage.setItem(STORAGE_KEY, cached)
    }
  } catch {
    cached = cached || generate()
  }
  return cached
}
